import { BffOe, OeKpis } from "aint-types";

import {
  ChartSeries,
  Scale,
} from "../../components/oe-kpi-chart-card/oe-kpi-chart-card";

export function getOeKpiChartSeries({
  selectedKpi,
  operatingEntity,
  scale,
}: {
  selectedKpi: keyof OeKpis;
  operatingEntity: BffOe;
  scale: Scale;
}): { labels: string[]; series: ChartSeries[] } {
  const labels: string[] = [];
  const series: ChartSeries[] = [
    {
      id: `${selectedKpi}-${scale}-line-plan`,
      data: [],
      label: "Plan",
      curve: "linear",
      color: "blue",
    },
    {
      id: `${selectedKpi}-${scale}-line-actual`,
      data: [],
      label: "Actual",
      curve: "linear",
      color: "orange",
    },
  ];
  const kpi = (operatingEntity[selectedKpi] ?? []).sort((kpiA, kpiB) => {
    if (kpiA.year !== kpiB.year) {
      return +kpiA.year - +kpiB.year;
    }
    return kpiA.quarter - kpiB.quarter;
  });

  for (const { planValue, actualValue, quarter, year } of kpi) {
    if (scale === "full") {
      labels.push(`${year} Q${quarter}`);
      series[0].data.push(planValue ?? 0);
      series[1].data.push(actualValue ?? 0);
    } else {
      const targetQuarter = +scale.charAt(1);

      if (quarter === targetQuarter) {
        labels.push(`${year} Q${quarter}`);
        series[0].data.push(planValue ?? 0);
        series[1].data.push(actualValue ?? 0);
      }
    }
  }

  return { labels, series };
}
